import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.404 2.63a9.02 9.02 0 0 1 12.73 0 9.002 9.002 0 1 1-12.73 12.731.75.75 0 0 1 0-1.06.74.74 0 0 1 1.059 0 7.5 7.5 0 1 0 0-10.612L2.56 5.546H4.5a.75.75 0 0 1 0 1.5H.535l-.038-.02H.47l-.037-.018H.403L.366 6.99l-.028-.018L.3 6.942l-.018-.018-.113-.103-.019-.029-.018-.028-.01-.018q-.01-.01-.01-.02L.095 6.7a.1.1 0 0 1-.01-.019q-.002-.011-.009-.019l-.018-.028a.06.06 0 0 0-.01-.037l-.003-.013q-.005-.009-.006-.025a.04.04 0 0 1-.01-.028.04.04 0 0 0-.004-.019q-.005-.006-.005-.019 0-.015-.006-.025L.01 6.455v-.038A.2.2 0 0 1 0 6.342v-3.75a.75.75 0 1 1 1.5 0v1.941zm7.115 5.934V4.496a.75.75 0 0 0-1.5 0V9.07l.004.012a.1.1 0 0 1 .005.025v.038c.01.009.01.018.01.037q.01.012.01.028l.018.038q0 .015.01.028.001.015.005.025l.004.012.018.028q0 .024.02.038l.018.028.019.028.018.038.02.018.008.011q.01.016.029.027l.019.019.028.028.028.019.028.018.037.028h.02l3.9 2.25c.111.071.242.107.374.104a.75.75 0 0 0 .375-1.397z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }